import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ErrorObject } from './models/ErrorObject';

@Component({
    selector: '.app-display-errors-message',
    templateUrl: './display-errors-message.component.html',
    styleUrls: ['./display-errors-message.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DisplayErrorsMessageComponent implements OnInit {
  @Input() error: ErrorObject;

  constructor() {}

  ngOnInit(): void {
    if (!this.error) {
      this.error = new ErrorObject();
    }
  }
}
